import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import DefaultFormLayoutClass from './DefaultFormLayout';
import HorizontalFormLayoutClass from './HorizontalFormLayout';
import MegaFormClass from './MegaFormClass';
import InlineFormClass from './InlineFormClass';

const FormDefaultContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs parent='Form Layout' title='Default Forms' subParent='Form Layout' pageTitle='Default Forms' />
      <Row>
        <Col sm='12' xl='6'>
          <Row>
            <DefaultFormLayoutClass />
            <HorizontalFormLayoutClass />
          </Row>
        </Col>
        <Col sm='12' xl='6'>
          <Row>
            <MegaFormClass />
            <InlineFormClass />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default FormDefaultContainer;
